import React from 'react'
import { connect } from 'react-redux'

export const FailedPayment = (props) => {
    return (
        <div>
        <div className="parent-width column centerItems centerContent parent-higth">
            <div className=" text-center text-bold text-fz-1-5 text-red ">PAGO FALLIDO</div>

        </div>
    </div>
    )
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(FailedPayment)
